export enum ApiEventType {
  ConnectivityClientDisconnect = 'CONNECTIVITY_CLIENT_DISCONNECT',
  ConnectivityLpDisconnected = 'CONNECTIVITY_LP_DISCONNECTED',
  PricingClientSubscriptionRejected = 'PRICING_CLIENT_SUBSCRIPTION_REJECTED',
  PricingLpSubscriptionRejected = 'PRICING_LP_SUBSCRIPTION_REJECTED',
  TradingBridgeLpSymbolInvalidVolume = 'TRADING_BRIDGE_LP_SYMBOL_INVALID_VOLUME',
  TradingBridgeLpVolumeTruncated = 'TRADING_BRIDGE_LP_VOLUME_TRUNCATED',
  TradingBridgeLpVolumeZero = 'TRADING_BRIDGE_LP_VOLUME_ZERO',
  TradingClientOrderSymbolNotFound = 'TRADING_CLIENT_ORDER_SYMBOL_NOT_FOUND',
  TradingLpCancellationNotConfirmed = 'TRADING_LP_CANCELLATION_NOT_CONFIRMED',
  TradingLpError = 'TRADING_LP_ERROR',
  TradingUnexpectedExecution = 'TRADING_UNEXPECTED_EXECUTION',
  TradingUnexpectedFokVolume = 'TRADING_UNEXPECTED_FOK_VOLUME',
}

export interface IApiRecipient {
  email: string;
  error?: string;
  sent: boolean;
}

export enum ApiAlertSeverity {
  Error = 'ERROR',
  Warning = 'WARNING',
}

export enum ApiAlertType {
  Connectivity = 'CONNECTIVITY',
  Ops = 'OPS',
  OpsClient = 'OPS_CLIENT',
  Pricing = 'PRICING',
  Risk = 'RISK',
  Trading = 'TRADING',
}

export interface IApiTriggeredAlert {
  id: number;
  emailSkipped: boolean;
  emailTitle: string;
  eventType: ApiEventType;
  guide?: string;
  message: string;
  recipients: IApiRecipient[];
  severity: ApiAlertSeverity;
  time: number;
  type: ApiAlertType;
}
